import { Resource } from '@models';

export interface FoundationResourceResult {
  foundationResource: Resource[];
}
